import React, { useEffect, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import useRazorpay from "react-razorpay";
import swal from "sweetalert2";

const RazorPay = ({ order_data, setIsordersuccess, bank_details }) => {
  debugger;
  const clientCode = JSON.parse(localStorage.getItem("clientCode"));
  const token = JSON.parse(localStorage.getItem("token"));
  const location = useLocation();
  const navigate = useNavigate();
  // const { amount_val, name, email, mobilNo } = location.state;
  const [razorPayData, setRazorPayData] = useState();
  const [orderData, setOrderData] = useState();
  const [Razorpay] = useRazorpay();

  const OpenPaymentWindow = (razorPayData) => {
    // debugger;
    //console.log(razorPayData);
    const options = {
      key: razorPayData.KEY,
      amount: razorPayData.amount,
      // amount: 1000,
      currency: "INR",
      name: "Prabhudas Lilladher",
      description: "Test Transaction",
      image: "",
      order_id: razorPayData.OrderID,
      // handler: (res) => {
      //   //console.log(res);
      // },
      handler: function (response) {
        debugger;
        //console.log("openwindow: " + response);
        updateTransactionStatusSignature(
          response.razorpay_order_id,
          response.razorpay_payment_id,
          response.razorpay_signature,
          razorPayData.ID
          //razorPayData.ID
          // "order_NJIie7agnVhg1X",
          // "pay_NJIisXC0DCodPM",
          // "9b6ea0faa4aaab0b1d88e867208502a492de4c2ae60d5e5d06958a89dc13c543"
        );
      },
      prefill: {
        name: razorPayData.name,
        email: razorPayData.email,
        contact: razorPayData.mobilNo,
      },
      notes: {
        address: "",
      },
      theme: {
        color: "##0a90cd",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
    // rzp1.on("payment.failed", function (response) {
    //   //console.log(response.error);
    // });
  };

  const updateTransactionStatusSignature = async (
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
    clientrefno
  ) => {
    const requestdata = {
      razorpay_order_id: razorpay_order_id,
      razorpay_payment_id: razorpay_payment_id,
      razorpay_signature: razorpay_signature,
      clientrefno: clientrefno,
    };
    debugger;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}RazorPay/PaymentComplete_Signature`,
        // "http://localhost:58620/api/RazorPay/PaymentComplete_Signature",
        requestdata,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status != 200) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      debugger;

      const newData = await response.data;
      //console.log("response from razorpay:", newData);
      let arrayresponse = newData.split(" ");
      if (arrayresponse[0] === "SUCCESS") {
        const orderparams = {
          symbol: order_data.symbol,
          orderNumber: order_data.order_no,
          price: order_data.issueprice,
          quantity: order_data.quantity,
          physicalDematFlag: order_data.physical_dematflag,
          clientCode: order_data.client_code,
          pan: order_data.pan,
          depository: order_data.depository,
          dpID: order_data.dpID,
          clientBenId: order_data.client_BenId,
          clientRefNumber: clientrefno,
          activityType: order_data.activity_type,
          clientName: order_data.name,
          rzorderid: razorpay_order_id,
          rzpaymentid: razorpay_payment_id,
        };

        placeOrder(
          "SGB/Order_Master",
          null,
          orderparams,
          process.env.REACT_APP_APIURL
        );
      }
    } catch (error) {
      //console.error("Error:", error);
      // Handle errors
    }
  };

  const placeOrder = async (apiEndpoint, setDataFunction, data, url) => {
    debugger;
    $("#CRloader").show();
    try {
      const response = await axios.post(`${url}${apiEndpoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          token: token,
          clientcode: clientCode,
          applicationname: "SGB",
        },
      });

      let newData = await response.data;
      newData = JSON.parse(newData);
      if (newData.Table1) {
        newData = await response.data.Table1;
      }
      // debugger;
      //console.log(newData);
      $("#CRloader").hide();
      new swal({
        title: "Success",
        text: `Your order has been successfully placed with order no: ${newData.orderNumber} and application no: ${newData.applicationNumber}`,
        icon: "success",
        button: "OK",
      }).then(() => {
        // navigate("/sgbdetails");
        setIsordersuccess(() => true);
      });

      //console.log(orderData);
    } catch (error) {
      //console.log("error while fetching", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const RZPAY = {
        IS_TPVRequired: "Y",
        OrderID: "",
        amount: order_data.price,
        //amount: 1,
        PaymentNotes: "TEST",
        name: order_data.name,
        email: order_data.email,
        mobilNo: order_data.mobilNo,
        city: "",
        subbrokerid: "",
        SourceApp: "SGBAPP",
        Reason: "",
        RerurnResponseURL: "/thankyou",
        BOID: "",
        FLCODE: "",
        Status: "",
        Error: "",
        Exchange: "NSE",
        Product: "SGB",
        AccountNo: bank_details.BKACNO,
        IFSC: bank_details.IFSC,
        ID: "",
        SYMBOL: order_data.symbol,
        CLIENTCODE: order_data.client_code,
        quantity: order_data.quantity,
        physicalDematFlag: order_data.physical_dematflag,
        pan: order_data.pan,
        depository: order_data.depository,
        dpID: order_data.dpID,
        clientBenId: order_data.client_BenId,
        activityType: order_data.activity_type,
        issueprice: order_data.issueprice,
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_APIURL}RazorPay/RazorPay`,
          RZPAY,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: token,
              clientcode: clientCode,
              applicationname: "SGB",
            },
          }
        );
        debugger;
        const newData = await response.data;
        setRazorPayData(newData);
        if (newData.OrderID != "Invalid Details") {
          OpenPaymentWindow(newData);
        } else {
          new swal({
            title: "Error",
            text: `Invalid Details`,
            icon: "error",
            button: "OK",
          });
        }
      } catch (error) {}
    };

    fetchData();
  }, []);

  return <div></div>;
};

export default RazorPay;
